import { post } from '../index'

export default {
  // 同步直播
  liveGetLive (querys) {
    return post('/livevideo/admin/AdminLive/getLive', querys)
  },
  // 直播列表
  liveLiveList (querys) {
    return post('/livevideo/admin/AdminLive/liveList', querys)
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/live.js